import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    stroke="currentColor"
    fill="transparent"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5.66658 5.58333V14.25C5.66658 15.4466 6.63663 16.4167 7.83325 16.4167H14.3333M5.66658 5.58333V3.41667C5.66658 2.22005 6.63663 1.25 7.83325 1.25H12.8012C13.0885 1.25 13.3641 1.36414 13.5672 1.5673L18.3493 6.34937C18.5524 6.55253 18.6666 6.82808 18.6666 7.1154V14.25C18.6666 15.4466 17.6965 16.4167 16.4999 16.4167H14.3333M5.66658 5.58333H3.33325C2.22868 5.58333 1.33325 6.47876 1.33325 7.58333V18.5833C1.33325 19.78 2.3033 20.75 3.49992 20.75H12.3333C13.4378 20.75 14.3333 19.8546 14.3333 18.75V16.4167" />
  </svg>
);
